import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class PhoneVerificationGuard implements CanActivate {
    private readonly router: Router;
    private readonly activatedRoute: ActivatedRoute;
    private readonly storageService: StorageService;

    constructor(storageService: StorageService, router: Router, activatedRoute: ActivatedRoute) {
        this.router = router;
        this.storageService = storageService;
        this.activatedRoute = activatedRoute;
    }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (this.storageService.getObjectFromSession(Keys.PHONE_VERIFICATION_REQUEST_TOKEN) || this.storageService.getItem(Keys.PROFILE_ID)) {
            return true;
        }
        this.router.navigate([`${route.url[0].path}/pan-verification`]);
        return false;
    }
}